import domready from 'domready/ready.min';
import GLightbox from 'glightbox';

const modalbanner = domready(function () {

    const cookiesList = document.cookie.split(';');
    const modalwidget = document.getElementById('modalwidget');
    const popupmodal = document.getElementById('popup_modal');

    if (cookiesList !== undefined && cookiesList.length > 0 && modalwidget) {
        cookiesList.forEach(function (bountyCookie) {
            if (bountyCookie.indexOf('Bounty') !== -1 && (parseInt(bountyCookie.split('=')[1]) >= 3)) {
                const boundyBanner = GLightbox({
                    elements: [
                        {
                            'content': modalwidget,
                            'closeButton': false,
                            'width': 830,
                            'height': 540,
                            'closeOnOutsideClick': false,
                        },
                    ]
                });
                boundyBanner.open();

                document.getElementsByClassName('gclose')[0].classList.add('hidden');

                document.getElementById('close-modal').addEventListener('click', function() {boundyBanner.close()}, false);

                boundyBanner.on('close', () => {
                    let date = new Date(new Date().getTime() + 2592000 * 1000);
                    document.cookie = "modalwidget_bounty=1; path=/; expires=" + date.toUTCString();
                });
            }
        });
    }
    else if(popupmodal){
        const modalBanner = GLightbox({
            elements: [
                {
                    'content': popupmodal,
                    'closeButton': false,
                    'width': 830,
                    'height': 540,
                    'closeOnOutsideClick': false,
                },
            ]
        });
        modalBanner.open();

        document.getElementsByClassName('gclose')[0].classList.add('hidden');

        document.getElementById('close-modal').addEventListener('click', function() {modalBanner.close()}, false);

        modalBanner.on('close', () => {
            let date = new Date(new Date().getTime() + 7 * 24 * 60 * 60 * 1000);
            document.cookie = "nobanner=1; path=/; expires=" + date.toUTCString();
        });
    }
})

export default modalbanner;
